export default function CodeEnforcementEntries() {
  return (
    <table id="filetable">
      <tr>
        <th>File Name</th>
        <th>Date Posted</th>
      </tr>
       {/*Start File*/}
        <tr>
        <td>
          <a href="../docs/code/UCC-Building-Permit-Regulations.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; PA UCC Building Permit Application Submittal Requirements
          </a>
        </td>
        <td>09/08/2026</td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
        <tr>
        <td>
          <a href="../docs/code/commercial-property-cert-o-u-202608251223.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Application for Certificate of Occupancy/Use <b>Commercial Property</b>
          </a>
        </td>
        <td>08/25/2026</td>
      </tr>
      {/*End File*/}
        {/*Start File*/}
        <tr>
        <td>
          <a href="../docs/code/annualfirepmt_20250409111942.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Annual Fire Permit Renewal and Business Information
          </a>
        </td>
        <td>04/09/2025</td>
      </tr>
      {/*End File*/}
       
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/code/Rental-Housing-Checklist-022025.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Rental Housing Checklist
          </a>
        </td>
        <td>02/21/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/code/Residential-Rental-License-Permit-Registration.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Residential Rental License Permit Registration
          </a>
        </td>
        <td>08/23/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/code/Morrisville-UCC-Permit-Application.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; UCC Permit Application
          </a>
        </td>
        <td>09/17/2024</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/code/Morrisville-Zoning-Permit-Application.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Zoning Permit Application
          </a>
        </td>
        <td>09/17/2024</td>
        {/*End File*/}
      </tr>
    </table>
  );
}
